import React from "react";
import { connect } from "react-redux";
import FormItem from "components/fields/FormItem";
import { Form, Input } from "antd";
import SelectOption from "components/select/SelectOption";
import { requiredField } from "utils/crudSagaHelper";
import Card from "components/card";
import DynamicList from "components/fields/DynamicList";
import TextArea from "antd/es/input/TextArea";

const JobDetails = () => {
    const [form] = Form.useForm();

    const onSubmit = (formData) => {
       
    };

    return (
        <Card className="rounded-2xl shadow-lg bg-white border-2 border-stale-200 mx-auto overflow-hidden">
            <div className="bg-gradient-to-br from-cyan-50 to-emerald-50 border-b rounded-t-xl p-6">
                <div className="flex items-center gap-4">
                    <div>
                        <h4 className="text-[18px] font-semibold text-gray-800">Job Details</h4>
                        <p className="text-[14px] text-gray-600">
                            Submit a hiring request and we'll find the perfect candidate for your team
                        </p>
                    </div>
                </div>
            </div>

            <Form 
                form={form}
                layout="vertical" 
                onFinish={onSubmit} 
            >
                <div className="pb-6 p-8 space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-7 gap-4">
                        <FormItem className="mb-2 col-span-5"
                            label="Job Title *"
                            rules={[requiredField()]}
                        >
                            <Input
                                className="input-field"
                                placeholder="e.g., Senior Software Engineer"
                            />
                        </FormItem>
                        <FormItem className="mb-2 col-span-2"
                            label="Status"
                            rules={[requiredField()]}
                        >
                            <SelectOption
                                placeholder="Select status"
                                options={[
                                    {label:"Draft", value: 0},
                                    {label:"Active", value: 1},
                                    {label:"Close", value: 2},
                                ]}
                            />
                        </FormItem>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-7 gap-4">
                        <FormItem className="mb-2 col-span-1"
                            label="Count *"
                            rules={[requiredField()]}
                        >
                            <Input
                                placeholder="1"
                                className="input-field"
                            />
                        </FormItem>
                        <FormItem className="mb-2 col-span-2"
                            label="Job Level *"
                            rules={[requiredField()]}
                        >
                            <SelectOption
                                placeholder="Select job level"
                                options={[
                                    {label:"Entry-Level", value: 0},
                                    {label:"Associate/Professional", value: 1},
                                    {label:"Mid-Leve;/Senior", value: 2},
                                    {label:"Manager", value: 3},
                                    {label:"Director", value: 4},
                                    {label:"Vice President", value: 5},
                                    {label:"Executive/C-suite", value: 6},
                                ]}
                            />
                        </FormItem>
                        <FormItem className="mb-2 col-span-4"
                            label="Location"
                            rules={[requiredField()]}
                        >
                            <Input
                                className="input-field"
                                placeholder="Enter location"
                            />
                        </FormItem>
                    </div>
                    <FormItem
                        label="Job Description *"
                        rules={[requiredField()]}
                    >
                        <TextArea
                            id=""
                            className="input-field"
                            maxLength={255}
                            placeholder="Describe the description for this role..."
                            rows={5}
                        />
                    </FormItem>
                    <div>
                        <DynamicList 
                            name=""
                            label="Key Responsibilities"
                            placeholder="Enter responsibility"
                            addButtonClass="text-gray-500 dark:text-white"
                        />
                        <DynamicList 
                            name=""
                            label="Preferred Qualifications"
                            placeholder="Enter responsibility"
                            addButtonClass="text-gray-500 dark:text-white"
                        />
                    </div>
                    <FormItem
                        label="Additional Information"
                        rules={[requiredField()]}
                    >
                        <TextArea
                            id=""
                            className="input-field"
                            maxLength={255}
                            placeholder="Describe the description for this role..."
                            rows={5}
                        />
                    </FormItem>
                    <FormItem
                        label="How to apply"
                        rules={[requiredField()]}
                    >
                        <TextArea
                            id=""
                            className="input-field"
                            maxLength={255}
                            placeholder="Describe the description for this role..."
                            rows={5}
                        />
                    </FormItem>
                </div>
            </Form>
        </Card>
    );
};

const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(JobDetails);
